import React from 'react';
import { LoginForm } from '@surfline/quiver-react';

import { useSignIn } from './useSignIn';

/**
 * @function SignIn
 * @return {JSX.Element}
 */
const SignIn = () => {
  const { signIn, error, loading } = useSignIn();

  return (
    <div className="sl-backplane-sign-in">
      <div className="sl-meter-bottom-sheet__title">Sign In</div>
      <LoginForm onSubmit={signIn} error={error} loading={loading} />
    </div>
  );
};

export default SignIn;
